import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import jQueryBridget from 'jquery-bridget';
import Isotope from "isotope-layout";
import '../sass/games.sass';
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { 
    faAngleRight,
    faAngleLeft,
    faSearch,
    faCheck,
    faCircleInfo,
    faFilter,
    faCircleXmark,
    faPlay,
    // 以下共用
    faEnvelope,
    faGlobe,
    faArrowUp,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import { 
    // 以下共用
    faFacebookF,
    faYoutube,
    faXTwitter,
    faInstagram,
    faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons'
library.add(
    faAngleRight, 
    faAngleLeft, 
    faSearch, 
    faCheck, 
    faCircleInfo, 
    faFilter, 
    faCircleXmark, 
    faPlay,
    faEnvelope,
    faGlobe,
    faArrowUp,
    faChevronRight,
    faFacebookF,
    faYoutube,
    faXTwitter,
    faInstagram,
    faLinkedinIn,)
dom.watch()
jQueryBridget('isotope', Isotope, $);


$(function () {
    const swiperBanner = new Swiper('.p-banner', {
        speed: 1000,
        spaceBetween: 10,
        loop: true,
        loopAdditionalSlides: 1,
        breakpoints: {
            1199: {
                spaceBetween: 60,
            },
            575: {
                loop: false,
                centeredSlides: false,
                spaceBetween: 30,
            },
        },
        centeredSlides: true,
        grabCursor: true,
        pagination: {
            el: '.p-banner .swiper-pagination',
            clickable: true,
        },
        modules: [Pagination, Autoplay],


    });

    const gameList = document.querySelectorAll(".game-list2-block");
    const clearSearchBtn = document.querySelector('.rwdFilter-search-clean');
    let pinyinInputDone = true; // 搜尋　input 拼音輸入完成
    let searchValue = "";
    let changeConditions = false;
    let checkboxListValue = {};
    const filterList = [
        { 
            name: "type",
            singleValue: true,
        },{ 
            name: "lineway",
            singleValue: true,
        },{ 
            name: "features",
            singleValue: false,
        },{ 
            name: "theme",
            singleValue: false,
        },
    ];
    filterList.forEach((filter) => {
        checkboxListValue[filter.name] = []
    })
    // isotope init
    let $grid = $('.game-list2').isotope({
        itemSelector: '.game-list2-block',
        transitionDuration: 300,
        layoutMode: 'fitRows',
        hiddenStyle: {
          opacity: 0
        },
        visibleStyle: {
          opacity: 1
        },
        masonry: {
            columnWidth: ".game-list2-block"
        }
    });

    window.addEventListener('popstate', () => {
        // console.log("popstate");
        updateCheckboxAryFromUrl(true);
    });

    // 手機版過濾條件面板開啟
    $('.filterShow-btn').on('click',function(){
        enableMobileFilterPanel();
    })

    // 手機版過濾條件面板關閉
    $('.rwdFilter-coverBg, .fliterClose').on('click', () => {

        const targetTop = $(".p-contaiter").offset().top - $('header').height()

        $('.sticky-box').removeClass('show')
        $('#socialfloating').removeClass('hide')
        $('main').removeClass('filterOpen')
        $('body').removeClass('filterOpen')
        
        if(changeConditions == true) {
            $('html,body').stop().animate({scrollTop: targetTop}, 500)
            changeConditions = false
        }
        
    })

    // 電腦版過濾類別展開
    $('.rwdFilter-dropdown-title').on('click', function(){
        

        if (filterShow === false) {
            $(this).parent().addClass('show');
            $('.rwdFilter-coverBg').addClass('show');
            filterShow = true;
        } else {
            switch($(this).parent().hasClass('show')) {
                case true:
                    $(this).parent().removeClass('show');
                    filterShow = false;
                    break;
                case false:
                    $(this).parent().addClass('show');
                    break;
            }
        }

    })

    // 清除搜尋 input 內容的按鈕動作
	clearSearchBtn.onclick = function() {
        const searchInput = document.querySelector('.rwdFilter-search');
		this.style.visibility = "hidden";
		searchInput.value = searchValue ="";
        runIsotope()
	};

    // 搜尋上的拼音輸入
    $('.rwdFilter-search').on({
        compositionstart: function(){
            pinyinInputDone = false
        },
        compositionend: function(){
            pinyinInputDone = true
            handleSearch($(this))
        },
        input: function(){
            handleSearch($(this))
        },
        keypress: function(e){
            if (e.kryCode == 13){
                pinyinInputDone = true
                handleSearch($(this))
            }
        },
    })
    // 清除所有搜尋條件
    $('.filterShowAll, .filterShowAllPc').on('click', () => {
        resetFilter();
    })

    // 改變遊戲顯示方式
    $('.display-mode svg').on('click', function() {

        if($(this).hasClass('active')) return;

        const switchTo = $(this)[0].classList[0];
        const currentMode = (switchTo === "card") ? "icon" : "card"
        $('.display-mode svg.active').removeClass('active');
        $(this).addClass('active');
        $('.game-list2').removeClass(`${currentMode}-mode`);
        $('.game-list2').addClass("loading-mode");
        $('.game-list2').addClass(`${switchTo}-mode`);
        document.cookie = `game_list_mode=${switchTo}`
        setTimeout(()=> {
            $grid.isotope("layout");
        }, 300)
        setTimeout(()=> {
            $('.game-list2').removeClass("loading-mode")
        }, 400)
    })

    // 改變條件
    $('input[type=checkbox]').on('change', function () {

        // console.log("checkbox.onchange")
        const val = parseInt(this.value)
        const currentProp = checkboxListValue[this.name];
        const hasFilterCondition = () => {
            return checkboxListValue[this.name].indexOf(val) >= 0
        }
        
        switch (this.checked) {
            case true:
                if (hasFilterCondition()) return;
                currentProp.push(val)
                break;
            case false:
                if (!hasFilterCondition()) return;
                currentProp.splice(currentProp.indexOf(val), 1)
                break;
        }
        runIsotope()
        
    })

    setTheNumberOfResults();
    setGameDisplayMode();
    updateCheckboxAryFromUrl();

    //
    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); }
        }
        return "";
    }

    //
    function setGameDisplayMode() {
        $(`.display-mode svg.active`).removeClass("active");
        $(`.game-list2`).removeClass("card-mode");
        $(`.game-list2`).removeClass("icon-mode");
        const cookieMode = getCookie("game_list_mode")
        const setMode = cookieMode === "" ? "card" : cookieMode;
        $(`.display-mode svg.${setMode}`).addClass("active");
        $(`.game-list2`).addClass(`${setMode}-mode`);
        setTimeout(()=> {
            $grid.isotope("layout");
        }, 300)
        setTimeout(()=> {
            $('.game-list2').removeClass("loading-mode")
        }, 400)
    }

    // 依網址更新搜尋條件
    function updateCheckboxAryFromUrl(resetBeforeUpdate = false) {
        let ldefaultSearch = window.location.search.substring(1).split("&")
        let checkboxAry = []
        if (resetBeforeUpdate) resetFilter();
        if (ldefaultSearch[0] != "") {
            ldefaultSearch.forEach(e => {
                let itemKey = e.split("=")[0]
                let itemVal = e.split("=")[1]
                let item = {}
                item[itemKey] = itemVal
                checkboxAry.push(item)
            })
            enableMobileFilterPanel();
            checkboxAry.forEach(e => {
                Object.values(e)[0]?.split(",").forEach(i => {
                    document.getElementById(Object.keys(e) + i).checked = true
                })
                document.querySelector(`.rwdFilter-dropdown.${Object.keys(e)} .rwdFilter-dropdown-title`).click();

                Object.values(e)[0].split(",").forEach(k => {
                    checkboxListValue[Object.keys(e)[0]].push(parseInt(k))
                })
            })
            runIsotope();
            changeConditions = false
        } else {
            $(".rwdFilter-dropdown.type").addClass("show");
        }
    }

    //
    function enableMobileFilterPanel() {
        // console.log("enableMobileFilterPanel");
        $('.sticky-box').addClass('show')
        $('#socialfloating').addClass('hide')
        $('main').addClass('filterOpen')
        $('body').addClass('filterOpen')
    }

    //
    function resetFilter() {
        // console.log("clean all filter")
        $('.rwdFilter-dropdown.show').removeClass('show')
        $('.rwdFilter-coverBg').removeClass('show')
        filterShow = false
        let allCheckbox = document.querySelectorAll("input[type='checkbox']")
        allCheckbox.forEach( (e) => {
            if(e.checked) e.click();
        })
        clearSearchBtn.click();
        document.querySelector(".rwdFilter-btnBox").classList.add("hidden");
        document.querySelector('.counter').innerHTML = gameList.length;
    }

    // isotope
    function runIsotope() { 
        changeConditions = true

        let numberOfFilterResults = 0

        // 依條件數量，設置該條件標題上的數字
        filterList.forEach((filter) => {
            const currentDom = document.querySelector(`.rwdFilter-dropdown.${filter.name} .rwdFilter-dropdown-title span`);
            currentDom.setAttribute("data-count",checkboxListValue[filter.name].length )
        });
        
        if (
            checkboxListValue.type.length > 0 || 
            checkboxListValue.lineway.length > 0 || 
            checkboxListValue.features.length > 0 || 
            checkboxListValue.theme.length > 0 || 
            searchValue != ""
        ) {
            $grid.isotope({
                filter: (ele) => {

                    let filterCheck = true;
                    let searchCheck = true;

                    Array.from(filterList).forEach((filter, index, arr) => {
                        const number = parseInt(ele.getAttribute(`data-${filter.name}`));
                        if (checkboxListValue[filter.name].length === 0) return;

                        const isValueInCheckboxList = (value) => checkboxListValue[filter.name].indexOf(value) !== -1;

                        if (filter.singleValue) {
                            if (!isValueInCheckboxList(number)) {
                                filterCheck = false;
                                arr.splice(index, arr.length - index);
                                return;
                            }
                        } else {
                            const propValue = JSON.parse(ele.getAttribute(`data-${filter.name}`)); // [2, 3, 7]
                            if (propValue.length === 0 || !propValue.some(e => isValueInCheckboxList(parseInt(e)))) {
                                filterCheck = false;
                                arr.splice(index, arr.length - index);
                                return;
                            }
                        }
                    })


                    if (searchValue !== "" ) {
                        searchCheck = (ele.getAttribute("data-name").toUpperCase().indexOf(searchValue) >= 0)
                    }
                    const totalCheck = filterCheck && searchCheck;
                    if (totalCheck) numberOfFilterResults += 1

                    return totalCheck

                }
            });
            document.querySelector('.rwdFilter-btnBox').classList.remove("hidden")
            document.querySelector('main').classList.add("filter-active")

            let locationSearch = "?"
            
            Object.values(checkboxListValue).forEach((e,i) => {
                if(e.length === 0) return;
                locationSearch += `${Object.keys(checkboxListValue)[i]}=${e.join(',')}&`
            })
            //不轉頁更新 URL
            let web_loca = window.location.protocol + '//' + window.location.host + location.pathname
            window.history.pushState({}, "", web_loca + locationSearch.slice(0, -1));

            if(numberOfFilterResults == 0) {
                $('.rwdFilter-noData').removeClass("d-none")
                $('.p-contaiter').addClass('no-filter-data');
            }else{
                $('.rwdFilter-noData').addClass("d-none")
                $('.p-contaiter').removeClass('no-filter-data');
            }


        } else {
            // console.log("無條件，不用篩選")
            $('.rwdFilter-noData').addClass("d-none");
            $('.p-contaiter').removeClass('no-filter-data');
            $grid.isotope({
                filter: '*'
            });
            document.querySelector('.rwdFilter-btnBox').classList.add("hidden")
            document.querySelector('main').classList.remove("filter-active")
            numberOfFilterResults = gameList.length
            //不轉頁更新 URL
            let web_loca = window.location.protocol + '//' + window.location.host + location.pathname
            window.history.pushState({}, "", web_loca);
        }
        const counterDom = document.querySelectorAll('.filterCount .counter');
        counterDom.forEach((e) => {
            e.innerHTML = numberOfFilterResults
        });
        
        let targetTop = ($("body").width() >= 768) ? 
            $(".containter-inner").offset().top - $('header').height() - 30 : 
            $(".p-contaiter").offset().top - $('header').height();

        $('html,body').stop().animate({scrollTop: targetTop}, 500)

    }

    // 處理搜尋上的拼音輸入
    function handleSearch(_this){
        if(pinyinInputDone) {
            clearSearchBtn.style.visibility = (_this.val().length) ? "visible" : "hidden";
            searchValue = _this.val().toUpperCase()
            runIsotope()
        }
    }

    // 預設 i18n 片語："共 {0} 項搜尋結果" 中的　{0} 為實際遊戲的數量
    function setTheNumberOfResults() {
        const counterList = document.querySelectorAll('.filterCount'); // "共 xxx 項搜尋結果"
        const totalGame = document.querySelectorAll(".game-list2-block").length // 所有的遊戲卡片
        const newElm = document.createElement('b')
        newElm.className  = 'counter'
        newElm.innerHTML = totalGame

        counterList.forEach(e => {
            e.style.opacity = 0;
            const localText = e.innerHTML
            const n = localText.replace("{0}",newElm.outerHTML);
            e.innerHTML = n
            e.style.opacity = 1;
        });
    };


})